export const DEFAULT_QUERY_OPTIONS = {
	staleTime: 1000 * 30 // 30 seconds
}
